import { cn } from "@tellescope/ui";
import { MessageSquareText, Phone } from "lucide-react";

export interface TextAndCallIconProps {
  className?: string;
}

export const TextAndCallIcon = ({ className }: TextAndCallIconProps) => (
  <span className={cn("relative inline-flex items-center justify-center", className)}>
    <MessageSquareText className="w-full h-full" strokeWidth={1.75} />
    <span className="absolute -bottom-[12%] -right-[12%] inline-flex items-center justify-center rounded-full bg-current w-[55%] h-[55%]">
      <Phone className="w-[60%] h-[60%] text-white fill-white" strokeWidth={2.5} />
    </span>
  </span>
);
